import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

import type { RouterContext } from './router-context';
import type { RouterHistory } from '@tanstack/react-router';

export function createAppRouter(context: RouterContext, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context,
    ...(history ? { history } : {}),
    defaultPreload: 'intent',
    scrollRestoration: true,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
